export default __webpack_public_path__ + "static/bucharestJS_logo-e61df9904d83041c24d31897db0d7d06.svg";